<template>
  <div class="row h-100">
    <div class="col-12 h-100 d-flex flex-column">
      <div class="d-flex justify-content-end mb-3 pb-1">
        <!-- fake inputs for disable autocomplite -->
        <div class="fake-inputs">
          <input id="username" type="text" name="fakeusernameremembered" />
          <input id="password" type="password" name="fakepasswordremembered" />
        </div>
        <b-button variant="danger" size="lg" @click="deleteUser" v-if="isSuperadmin">
          {{ 'Delete' | i18n }}
        </b-button>
        <b-button variant="primary" size="lg" class="ml-3" @click="onSubmit" :disabled="!canSave" v-if="isSuperadmin || user.role !== 'superadmin'">
          {{ 'save' | i18n }}
        </b-button>
      </div>
      <div v-if="loaded" class="poppins overflow-x-hidden overflow-auto pr-1 flex1">
        <div class="inputs-block">
          <BlockHeader name="Details" class="mt-0" />
          <div class="row">
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.username" form-group-id="name" placeholder="name" />
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Select v-model="user.role" :options="rolesOptions" form-group-id="user_role" placeholder="user_role" />
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.email" form-group-id="email" placeholder="email" autocomplete="off" type="email" :update-error="updateError" />
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input
                v-model="user.alternativeEmail"
                form-group-id="email"
                placeholder="Alternative E-Mail Address"
                autocomplete="off"
                customID="AlternativeEmail"
              />
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.pushToken" form-group-id="email" placeholder="Push token" :viewMode="true" />
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Select
                v-model="user.language"
                :options="languagesOptions"
                form-group-id="Language"
                placeholder="Language"
                inputPlaceholder="Select language"
              />
            </div>
            <div style="height: 35px; width: 100%"></div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.group" form-group-id="group" placeholder="Corporation" />
            </div>
            <div class="col-lg-6 col-sm-0 col-xs-0"></div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.company" form-group-id="company" placeholder="Company" />
            </div>
            <div class="col-lg-6 col-sm-0 col-xs-0"></div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input v-model="user.operatingSites" form-group-id="operatingSites" placeholder="Operational Area" />
            </div>
            <div class="col-lg-6 col-sm-0 col-xs-0"></div>
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Input
                v-model="user.personnelNumber"
                type="tel"
                :error="!!user.personnelNumber && isPhoneError"
                :errorMessage="'phone_number_error' | i18n"
                form-group-id="group"
                placeholder="Personnel Number"
              />
            </div>
          </div>
        </div>
        <div class="inputs-block">
          <div class="row">
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <BlockHeader name="Attributes" />
              <div class="att-wrapper">
                <div class="att-line item-shadow" v-for="(att, index) in attributes" :key="`${index}-att-${att}`">
                  <div class="att-name">{{ att }}</div>
                  <div class="delete-button" @click="deleteAtt(index)">
                    {{ 'Delete' | i18n }}
                  </div>
                </div>
                <div class="att-line item-shadow align-items-end">
                  <Input v-model="newAtt" form-group-id="Attribute" placeholder="Attribute" autocomplete="off" />
                  <b-button variant="primary" size="lg" style="line-height: 30px" @click="addAtt" :disabled="!newAtt">
                    {{ 'Add' | i18n }}
                  </b-button>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-12 col-xs-12" v-if="isSuperadmin">
              <BlockHeader name="Password" />
              <div class="row">
                <div class="col-lg-8 col-sm-8 col-xs-8">
                  <Input
                    v-model="newPassword"
                    form-group-id="New password"
                    placeholder="New password"
                    type="password"
                    autocomplete="off"
                    customID="Password"
                  />
                </div>
                <div class="col-lg-4 col-sm-4 col-xs-4 pt-4">
                  <b-button variant="primary" size="lg" class="mt-1" :disabled="!canSavePassword" style="line-height: 30px" @click="updatePassword">
                    {{ 'Update password' | i18n }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inputs-block" v-if="isSuperadmin && id">
          <QRCodeModal id="QRCodeModal" :userId="id" :expiresIn="expiresIn" :qrCodeId="qrCodeId" />
          <BlockHeader name="QR Code" />
          <div class="row">
            <div class="col-lg-6 col-sm-12 col-xs-12">
              <Select v-model="expiresIn" :options="expiresInOptions" form-group-id="liveTime" :placeholder="'QR Live time' | i18n" />
            </div>
            <!-- <div class="col-lg-6 col-sm-12 col-xs-12">
                <b-button variant="primary" size="sm" @click="showQRCode">
                  {{ 'Show QR code' | i18n }}
                </b-button>
              </div> -->
            <div class="col-lg-6 col-sm-12 col-xs-12 pt-4">
              <b-button variant="primary" size="lg" class="mt-1" style="line-height: 30px" @click="createQRCode">
                {{ 'Create QR code' | i18n }}
              </b-button>
            </div>
          </div>
        </div>
        <div class="inputs-block" v-if="isSuperadmin && id">
          <Table
            :update="getPage"
            :columns="columns"
            :rows="rows"
            :loading-instance="loadingInstance"
            :set-loading-instance="setLoadingInstance"
            :pagination="false"
            tableName="userDetailsTable"
          />
        </div>
      </div>
      <Loader v-else />
    </div>
  </div>
</template>
<script>
import { BIconPlus } from 'bootstrap-vue';
import moment from 'moment';

import api from '../../../api/index';
import QRCodeModal from '../../../modals/QRCode';
import Input from '../../common/input';
import Checkbox from '../../common/checkbox';
import Select from '../../common/select';
import BlockHeader from '../../common/block-header';
import PageHeader from '../../common/page-header';
import Loader from '../../common/loader';
import Table from '../../common/table';
import { UserMixin, NotificationMixin, DeleteRowMixin, AuthMixin, LicenseMixin, ProjectsMixin } from '../../../../mixins';
import { ROLES, TRANSLATE_LANGUAGE, ROLES_NAMES } from '../../../../../../../constants';

export default {
  title: 'Add list',
  components: { Input, BlockHeader, BIconPlus, PageHeader, Loader, Select, QRCodeModal, Checkbox, Table },
  mixins: [UserMixin, NotificationMixin, DeleteRowMixin, AuthMixin, LicenseMixin, ProjectsMixin],
  data() {
    return {
      expiresIn: 86400,
      expiresInOptions: [
        { value: 86400, text: '1 day' },
        { value: 86400 * 30, text: '30 days' },
        { value: 'never', text: 'Never' },
      ],
      loaded: false,
      user: {},
      rolesOptions: Object.values(ROLES).map((v) => ({
        value: v,
        text: this.$translate(ROLES_NAMES[v]),
      })),
      newAtt: '',
      newPassword: '',
      inputError: false,
      attributes: [],
      id: '',
      qrCodeId: null,
      columns: [
        {
          field: 'expiresIn',
          title: this.$translate('expiry_time'),
          key: '6',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            const getTimeMessage = (t) => {
              switch (String(t)) {
                case 'never':
                  return this.$translate('Never');
                case '86400':
                  return `1 ${this.$translate('day')}`;
                case '2592000':
                  return `30 ${this.$translate('days')}`;
              }
            };
            return <span>{getTimeMessage(row.expiresIn)}</span>;
          },
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          width: 240,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="copy-button" on-click={() => this.showQRCode(row)}>
                  {this.$translate('QR Code')}
                </div>
                <div class="delete-button" on-click={() => this.deleteQRCode(row.id)}>
                  {this.$translate('Delete')}
                </div>
              </div>
            );
          },
        },
      ],
      rows: [],
      loadingInstance: null,
    };
  },
  computed: {
    canSave: function () {
      return (this.user.username || this.user.email) && this.user.role;
    },
    canSavePassword: function () {
      return this.newPassword && this.newPassword.length >= 6;
    },
    languagesOptions: function () {
      return this.languages.map((l) => ({ value: l.value, text: l.name }));
    },
    isPhoneError: function () {
      const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
      return !regex.test(this.user.personnelNumber);
    },
  },
  async created() {
    this.id = this.$route.params.id;
    if (this.id) {
      const user = await this.userService.getById(this.id);
      this.user = user.data;
      if (!this.user.pushToken) {
        this.user.pushToken = '-';
      }
      this.attributes = this.user.attributes;
    }

    this.languages = Object.keys(TRANSLATE_LANGUAGE).map((key) => ({ name: key, value: TRANSLATE_LANGUAGE[key] }));

    this.loaded = true;
  },
  methods: {
    async deleteQRCode(id) {
      try {
        await this.deleteSelectedRows({}, async () => {
          await api.qrManagement.delete({ ids: [id] });
          this.getPage();
        });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    async createQRCode() {
      try {
        await api.qrManagement.post({ id: this.id, expiresIn: this.expiresIn });
        await this.getPage();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    showQRCode(qr) {
      this.qrCodeId = qr.id;
      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'QRCodeModal');
      }, 10);
    },
    updateError(e) {
      this.inputError = e;
    },
    deleteAtt(i) {
      this.attributes.splice(i, 1);
    },
    addAtt(i) {
      this.attributes.push(this.newAtt);
      this.newAtt = '';
    },
    async deleteUser() {
      await this.deleteSelectedRows(null, async () => {
        try {
          await this.userService.deleteUsers([this.user.id]);
          this.$router.push({ name: 'users' });
          this.showNotification({ type: 'success', message: this.$translate('success') });
        } catch (err) {
          this.stopLoading();
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    async updatePassword() {
      try {
        await this.userService.resetUserPassword(this.user.id, { newPassword: this.newPassword });
        this.newPassword = '';
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        console.log(err, 'err');
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async onSubmit() {
      try {
        const u = this.user;
        const payload = {
          username: u.username,
          email: u.email,
          alternativeEmail: u.alternativeEmail,
          role: u.role,
          group: u.group,
          company: u.company,
          language: u.language,
          operatingSites: u.operatingSites,
          personnelNumber: u.personnelNumber,
          attributes: this.attributes,
          id: u.id,
        };
        await this.userService.update(payload);
        this.$router.push({ name: 'users' });
        this.showNotification({ type: 'success', message: this.$translate('success') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const response = await api.qrManagement.getForUser(this.id);
        this.stopLoading();
        this.rows = response;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #add-team .modal-dialog {
  max-width: 700px !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.header {
  color: #5f5f5f !important;
  font-size: 1.6rem !important;
  font-weight: 400;
  text-transform: uppercase;
  margin-right: 20px;
}

.item-text {
  color: #5f5f5f !important;
  font-size: 1.2rem !important;
  font-weight: 400;
  margin-left: 20px;
  margin-top: 10px;
}

.header-block {
  width: 100%;
  display: flex;
  align-items: center;
}

.item-block {
  display: flex;
  margin-bottom: 30px;
}

.item-wrapper {
  padding-left: 25px;
}
.item-shadow {
  width: 100%;
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  padding: 10px;
  margin-bottom: 15px;
}

.att-line {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  .form-group {
    margin: 0;
  }
}

::v-deep .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .add-button {
  background: linear-gradient(#2260ff, #2260ff);
  color: white;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
  min-width: 80px;
  text-align: center;
  margin-bottom: 3px;
}

.password-wrapper {
  display: flex;
  justify-content: space-between;
}

.reset-text {
  color: #80868b;
  font-size: 13px;
}

.fake-inputs {
  position: absolute;
  z-index: -10;
  top: -500;
  opacity: 0;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

::v-deep .action-block {
  display: flex;
  justify-content: center;
}

::v-deep .action-buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.action-buttons-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-buttons-wrapper button {
  white-space: nowrap;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

.overflow-x-hidden {
  overflow-x: hidden!important;
}
</style>
